import { render, staticRenderFns } from "./imageUploadComponent.vue?vue&type=template&id=03921bc7&"
import script from "./imageUploadComponent.vue?vue&type=script&lang=js&"
export * from "./imageUploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports